import { render, staticRenderFns } from "./PushMessageCreation.vue?vue&type=template&id=4c9bb818&scoped=true"
import script from "./PushMessageCreation.vue?vue&type=script&lang=js"
export * from "./PushMessageCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9bb818",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c9bb818')) {
      api.createRecord('4c9bb818', component.options)
    } else {
      api.reload('4c9bb818', component.options)
    }
    module.hot.accept("./PushMessageCreation.vue?vue&type=template&id=4c9bb818&scoped=true", function () {
      api.rerender('4c9bb818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/messagePush/PushMessageCreation.vue"
export default component.exports